import { render, staticRenderFns } from "./NavTypeCard.vue?vue&type=template&id=6a61940f&scoped=true"
import script from "./NavTypeCard.vue?vue&type=script&lang=js"
export * from "./NavTypeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a61940f",
  null
  
)

export default component.exports